/* Drapeaux du sélecteur de langue, dessinés en SVG (aucune dépendance,
 * aucun emoji, rendu identique sur tous les systèmes). */

const FLAGS = {
    fr: (
        <>
            <rect width="20" height="30" fill="#0055A4" />
            <rect x="20" width="20" height="30" fill="#FFFFFF" />
            <rect x="40" width="20" height="30" fill="#EF4135" />
        </>
    ),
    en: (
        <>
            <rect width="60" height="30" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="2.5" />
            <path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth="10" />
            <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
        </>
    ),
    es: (
        <>
            <rect width="60" height="30" fill="#AA151B" />
            <rect y="7.5" width="60" height="15" fill="#F1BF00" />
        </>
    ),
};

export const Flag = ({ lang, width = 20 }) => (
    <svg
        viewBox="0 0 60 30"
        width={width}
        height={width / 2}
        aria-hidden="true"
        focusable="false"
        style={{
            borderRadius: 2,
            boxShadow: "0 0 0 1px rgba(59,42,34,0.18)",
            display: "block",
        }}
    >
        {FLAGS[lang]}
    </svg>
);
